import logoDark from '@/assets/images/logo-dark.png';
import { useColorModeValue } from '@chakra-ui/react';

export const useLogo = () => {
  return useColorModeValue(logoDark, logoDark);
};
